import * as actionTypes from './types';

const INITIAL_STATE = {
  byNode: {}, // nodeId -> { data: SelfCapabilities | null, loading }
  activeId: null // the node the rest of the app is gated on
};

const withEntry = (state, { nodeId, active }, entry) => ({
  ...state,
  byNode: { ...state.byNode, [nodeId]: entry },
  activeId: active ? nodeId : state.activeId
});

const capabilitiesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CAPABILITIES_LOADING:
      return withEntry(state, action.payload, {
        data: state.byNode[action.payload.nodeId]?.data ?? null,
        loading: true
      });
    case actionTypes.FETCH_CAPABILITIES_SUCCESS:
      return withEntry(state, action.payload, { 
        data: action.payload.data, 
        loading: false 
      });
    case actionTypes.FETCH_CAPABILITIES_FAILED:
      return withEntry(state, action.payload, { data: null, loading: false });
    default:
      return state;
  }
};

export default capabilitiesReducer;
